export const iconFontAwesomeMapsTrainTram = (
	<i className="fa-solid fa-train-tram"></i>
);
